import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { TicketGuideComponent } from './ticket-guide.component';
import { UIRouterModule } from '@uirouter/angular';
import { Transition } from '@uirouter/angular';
import { STATE_TICKET } from '../../shared/app-states';
import { OrderKeywordsAddonComponent } from './order-keywords-addon.component';
import { OrderSearchResultComponent } from './order-search-result.component';
import { SowActivationComponent } from './sow-activation.component';
import { FaqTicketCategoryComponent } from './faq-ticket-category.component';
import { GaStateDeclaration } from '../../../type_definitions/datatypes';

const states:GaStateDeclaration[] = [
  {
    name: STATE_TICKET,
    url: '/tickets/guide?orderId&workflowTypes&webshopId&countryId',
    params: {
      orderId: {
        dynamic: true
      },
      webshopId: {
        dynamic: true
      },
      countryId: {
        dynamic: true
      }
    },
    views: {
      content: {
        component: TicketGuideComponent
      }
    },
    data: {
      translate: true
    },
    resolve: [
      {
        token: 'orderId',
        deps: [ Transition ],
        resolveFn: (transition:Transition) => Number(transition.params()?.orderId)
      },
      {
        token: 'workflowTypes',
        deps: [ Transition ],
        resolveFn: (transition: Transition) => transition.params()?.workflowTypes?.split(',')
      },
      {
        token: 'webshopId',
        deps: [ Transition ],
        resolveFn: (transition: Transition) => transition.params()?.webshopId
      },
      {
        token: 'countryId',
        deps: [ Transition ],
        resolveFn: (transition: Transition) => transition.params()?.countryId
      }
    ]
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({ states }),
    CommonModule,
    SharedModule
  ],
  declarations: [
    TicketGuideComponent,
    OrderKeywordsAddonComponent,
    OrderSearchResultComponent,
    SowActivationComponent,
    FaqTicketCategoryComponent
  ]
})
export class TicketGuideModule { }